export default "__VITE_ASSET__39a6d02b__"